<template>
  <v-card
    ref="navContentContainer"
    flat
    height="100%"
    width="100%"
    v-resize="onResize"
    class="segment-view"
  >
    <portal to="context-portal">
      <div class="d-flex">
        <div class="d-flex">
          <img
            :src="$ic.getImageUrl('profile', profiler.calcProfile(segment))"
            class="medium-thumbnail"
            :class="segment.climb_category !== 0 ? 'image-color-warning' : 'image-accent-dark'"
          />
          <h3 v-if="segment" class="ma-1 fg-accent-dark">{{ segment.name }}</h3>
        </div>
        <div class="ml-auto mr-2">
          <div v-if="segment.distance" class="text-xs-right">
            <h3 class="fg-accent-dark" v-html="$bc.distanceFormat(segment.distance,'minor')" />
            <small v-if="elevation"
              class="fg-accent-dark"
              v-html="$bc.elevationFormat(elevation, true)"
            />
          </div>
        </div>
      </div>
    </portal>
    <l-map-view
      v-if="bottomNav === 'map'"
      ref="map"
      :style="contentStyle"
      :polyline="polyline"
      :bounds="bounds"
      :show-attribution="false"
    />
    <div v-if="bottomNav === 'details'" :style="contentStyle" class="segment-details">
      <pre>{{ segment }}</pre>
    </div>
    <v-bottom-nav
      :active.sync="bottomNav"
      :value="true"
      :style="navBarStyle"
      color="transparent"
      ref="navBar"
    >
      <v-btn color="primary" flat value="map">
        <span>Map</span>
        <v-icon>map</v-icon>
      </v-btn>
      <v-btn color="primary" flat value="efforts">
        <span>Attempts</span>
        <v-icon>timer</v-icon>
      </v-btn>
      <v-btn color="primary" flat value="details">
        <span>Details</span>
        <v-icon>equalizer</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-card>
</template>
<script>
import profiler from '@/domain/ProfileAnalyzer';
import eventBus from '@/events/eventBus';
import LMapView from '@/ux/generic-components/LMapView.vue';
import loadingMixin from '@/mixins/loadingMixin';
import dataAccessor from '@/data-access/dataAccessor';

export default {
  name: 'segment-view',
  components: { LMapView },
  mixins: [loadingMixin],
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    polyline: null,
    mapOnly: false,
    polyline: [],
    bottomNav: 'details',
    contentHeight: '',
    footerTop: 600,
    navBarTop: 600,
    segment: {},
    profiler,
  }),
  computed: {
    bounds() {
      let bnds = null;
      if (this.hoveredSegment) {
        bnds = geometry.bounds([geometry.toLatLng(this.hoveredSegment.segment.start_latlng),
        geometry.toLatLng(this.hoveredSegment.segment.end_latlng)]);
      }
      return bnds;
    },
    contentStyle() {
      return `height: ${this.contentHeight};`;
    },
    navBarStyle() {
      const h = this.$refs.navBar ? this.$refs.navBar.$el.clientHeight : 56;
      this.navBarTop = this.footerTop - h;
      return `position: fixed;top: ${this.navBarTop}px;`;
    },
    elevation() {
      let elevation = this.segment ? this.segment.elevation_high - this.segment.elevation_low : undefined;
      if (elevation && (this.segment.average_grade < 0)) {
          elevation = (-elevation);
      }
      return elevation;
    }
  },
  mounted() {
    eventBus.on('viewport-changed', this.setViewport);
    this.setViewport();
    this.load();
  },
  methods: {
    async load() {
      this.loadingStart(`Loading segment`);
      //   const d = new PolylineDecoder();
      this.segment = await dataAccessor.getSegment(this.id);
      this.polyline = await dataAccessor.getSegmentStreams(this.id);
      //   this.centre = { lat: this.activity.start_latlng[0], lng: this.activity.start_latlng[1] };
      //   this.polyline = this.activity && this.activity.map ? this.activity.map.polyline : [];
      this.loadingEnd();
      //   this.attachMapButtons();
    },
    setViewport() {
      this.footerTop = this.$store.getters.viewport.bottom;
      this.$nextTick(() => {
        this.contentHeight = this.calcContentHeight();
      });
    },
    async onResize(args) {
      this.contentHeight = this.calcContentHeight();
    },
    calcContentHeight() {
      if (this.$refs.navContentContainer && this.$refs.navBar) {
        const r1 = this.$refs.navContentContainer.$el.getBoundingClientRect();
        const hm = `${this.navBarTop - r1.top}px`;
        return hm;
      }
    },
  },
}
</script>
<style lang="scss">
.segment-view {
  .segment-details {
    overflow-y: auto;
  }
}
</style>